<!-- 企业介绍 -->
<template>
<div class="companiesIntroduce_lyout">
    <carouselView 
        :bannerList="bannerList" 
        :fileUrl="fileBaseUrl"
        height="2rem"
        imgHeight="2rem"
        >
    </carouselView>

    <div class="defalut_content companiesIntroduce_lyout_content">
        <div class="companiesIntroduce_lyout_lookUp">
            <customLookupTitle iconfont="icon-zu405-19" title="企业介绍" distance="10px"></customLookupTitle>
            
            <div class="companiesIntroduce_lyout_lookUp_introduction">
                <img :src="require('assets/images/about/companyIntroduce/introduction.png')" alt="">
                <pre class="content">{{introduction}}</pre>
            </div>

            <div class="companiesIntroduce_lyout_lookUp_count">
                <div v-for="(item,index) in conutList" :key="index" class="item">
                    <div class="item_circle">
                        <div class="item_circle_num">{{item.num}}</div>
                        <div class="item_circle_unit">{{item.unit}}</div>
                    </div>
                    <div class="item_name">{{item.name}}</div>
                </div>
            </div>
        </div>

        <div class="companiesIntroduce_lyout_development_history">
            <customOptionsTitle title="发展历程"></customOptionsTitle>
            <customTimeLine class="companiesIntroduce_lyout_development_history_content" :dataList="developmentHistory">
                <template slot-scope="scope">
                    <div class="development_history_item">
                        <img class="development_history_item_img" :src="scope.item.url" alt="">
                        <div class="development_history_item_text">
                            <div class="text_time">{{scope.item.time}}</div>
                            <pre class="text_other">{{scope.item.instructions}}</pre>
                        </div>
                    </div>
                </template>
            </customTimeLine>
        </div>

        <div class="companiesIntroduce_lyout_honorary_certificate">
            <customOptionsTitle title="荣誉资质"></customOptionsTitle>
            <div class="one">
                <div v-for="(item,index) in honoraryCertificate.one" :key="'one_'+index" class="one_item">
                    <img :src="item.url" alt="">
                    <div class="one_item_name">{{item.name}}</div>
                </div>
            </div>
            <div class="two">
                <template v-for="(item,index) in honoraryCertificate.two">
                    <div :class="{marginLeft37:index%5!=0}" :key="'two_'+index" class="two_item">
                        <img :src="item.url" alt="">
                        <div class="two_item_name often-nolyOneLine2">{{item.name}}</div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import carouselView from 'views/generalView/carouselView.vue'
    import customLookupTitle from 'components/custom-lookup/custom-lookup-title.vue'
    import customOptionsTitle from 'components/custom-options-title/custom-options-title.vue'
    import customTimeLine from 'components/custom-time-line/custom-time-line.vue'
    import baseView from "views/base/baseView.vue";
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import dataConfig from "config/about/companiesIntroduce.data.config.js";
    import metaInfoUtils from 'config/metaInfo.config.js';

    export default {
        extends:baseView,
        metaInfo: metaInfoUtils.currentMetaInfo('/about/companies-introduce'),
        components: {
            carouselView,customLookupTitle,customOptionsTitle,customTimeLine
        },
        computed: {
            ...mapGetters(['userInfo']),
        },
        data() {
            return {
                bannerList:dataConfig.bannerList,
                introduction:dataConfig.introduction,//简介
                conutList:dataConfig.conut,
                developmentHistory:dataConfig.developmentHistory,//发展历程
                honoraryCertificate:dataConfig.honoraryCertificate,//荣誉资质
            };
        },
        watch:{
           
        },
        created(){
        },
        methods: {
        }
    }
</script>

<style lang="less" scoped>
@import url("./companiesIntroduce.less");
</style>
